import { render, staticRenderFns } from "./ClaimEditDescriptionDialog.vue?vue&type=template&id=7b10d35d&"
import script from "./ClaimEditDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimEditDescriptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports